
import efebe from '../images/common/animus_employee_Efebe.png';
import astaradai from '../images/common/astaradai_pfp.png';
import swat from '../images/common/Swat_pfp.png';
import shadowregister from '../images/common/Shadow_pfp.png';
import ev from '../images/common/Ev_pfp.png';
import zander from '../images/common/Zander_pfp.png';
import crafty from '../images/common/Crafty_Pie_pfp.png';
import bre from '../images/common/bre_pfp.png';
import restart from '../images/common/Restart_pfp.png';
import killerface from '../images/common/Killerface_pfp.png';
import shenlong from '../images/common/Shenlong_pfp.png';
import duke from '../images/common/duke_pfp.png';



const dataTeam = [
    {
        id: 1,
        img: zander,
        name: 'Zander',
        position: 'Co-founder',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: 'https://twitter.com/Zanderofrome'
            },
        ]
    },
    {
        id: 2,
        img: ev,
        name: 'Ev',
        position: 'Co-founder',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: 'https://twitter.com/0xEvv'
            },
        ]
    },
    {
        id: 3,
        img: shadowregister,
        name: 'ShadowRegister',
        position: 'Co-founder & CTO',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: 'https://twitter.com/shadowregister'
            },
        ]
    },
    {
        id: 4,
        img: swat,
        name: 'Swat',
        position: 'Co-founder & Lead Artist',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
    {
        id: 5,
        img: efebe,
        name: 'Efebe',
        position: 'Lead Artist',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: 'https://twitter.com/Pixel_Salvaje'
            }
        ]
    },
    {
        id: 6,
        img: crafty,
        name: 'TheCraftyPie',
        position: 'Senior Developer',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: 'https://twitter.com/crypto_wsk'
            }
        ]
    },
    {
        id: 7,
        img: bre,
        name: 'Bre',
        position: 'Project Lead',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            },
        ]
    },
    {
        id: 8,
        img: duke,
        name: 'Duke',
        position: 'Artist',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
    {
        id: 9,
        img: astaradai,
        name: 'Astaradai',
        position: 'Writer',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
    {
        id: 10,
        img: killerface,
        name: 'Killerface',
        position: 'Junior Developer',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
    {
        id: 11,
        img: restart,
        name: 'Restart',
        position: 'Junior Developer',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
    {
        id: 12,
        img: shenlong,
        name: 'Shenlong',
        position: 'Junior Developer',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            }
        ]
    },
]

export default dataTeam;